<template>
  <carousel
    class="index-carousel"
    :autoplay="true"
    :minSwipeDistance="40"
    :scrollPerPage="true"
    :speed="500"
    :perPage="setting.pageSize"
    :loop="true"
    :navigationEnabled="false"
    :paginationEnabled="false"
    ><!-- :paginationPadding="10" :paginationSize="10" -->
    <!-- 		 <slide>
		      Slide 1 Content
		    </slide>
		    <slide>
		      Slide 2 Content
		    </slide> -->
    <!-- 		<slide class="items-carousel" v-for="(item,index) in bitems">
			<div style="width:100%">
				<a :href="item.url" class="item"><img :src="item.target" alt="" style="width:100%"></a>
			</div>
		</slide> -->
    <slide class="items-carousel" v-for="(item, index) in items" :key="index">
      <div  style="width: 100%;padding:0px 10px">
          <a :href="item.hrefUrl" >
        <div class="item" :style="setting.isremark?'padding-bottom:10px;':''">
 
          <img
            :src="$util.fixProtocol(item.targetUrl)"
            alt=""
            style="width: 100%"
        /><strong v-show="setting.isremark">{{$Lang.L({cn:item.displayName,en:item.displayNameEn,hk:''})}}</strong><b v-show="setting.isremark">{{item.remark}}</b>
        </div>  
          </a> 
      </div>
    </slide>
  </carousel>
</template>

<script>
import { Carousel, Slide } from "vue-carousel";
export default {
  props: ["items", "configs"],
  components: {
    Carousel,
    Slide,
  },
  data() {
    return {
      
      setting:{
        isremark:true,
        pageSize: 5,
      },
      ishttps:false
    };
  },
  watch: {
      'setting'(){

      }
  },
  beforeMount(){

  },
  mounted() {
    // debugger
     if(this.configs) this.setting=this.configs
  },
};
</script>

<style scoped="scoped">
a{
   text-decoration-line: none;
}
a:hover{
   text-decoration-line: none;
}
a:active{
  text-decoration-line: none;
}
.item{
  
  text-align: center;
	background: rgba(0,0,0,0.3);
    transition: all 0.6s ease;
    -o-transition: all 0.6s ease;
    -moz-transition: all 0.6s ease;
    -webkit-transition: all 0.6s ease;	
}
.item:hover{
  	background: #E6400C;
    transition: all 0.9s ease;
    -o-transition: all 0.9s ease;
    -moz-transition: all 0.9s ease;
    -webkit-transition: all 0.9s ease;	
}
.item strong{
  margin-top:10px;
  margin-bottom: 5px;
  color: #eee;
	display: block;
	font-size: 16px;
	font-weight: 300;
}
.item b{
  margin-bottom: 10px;
  color: #eee;
	font-weight: 300;
}
</style>